import { render } from "./UploadChunkFile.vue?vue&type=template&id=1fc8af16"
import script from "./UploadChunkFile.vue?vue&type=script&lang=js"
export * from "./UploadChunkFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__